import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistGetProfileLanguagesRequest } from '@/shared/api/requests/artist/languages/get/request';
import { artistGetProfileLanguages } from '@/shared/api/requests/artist/languages/get/request';

export const useArtistProfileLanguagesQuery = (
  params: ArtistGetProfileLanguagesRequest,
  settings?: QuerySettings<typeof artistGetProfileLanguages>
) =>
  useQuery({
    queryKey: ['ArtistProfileLanguages', params.profileId],
    queryFn: () =>
      artistGetProfileLanguages({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
